export class TypeResultatSaisie {
  public static CODES = 'CODES';
  public static NUMERIQUE = 'NUMERIQUES';
  public static DATE = 'DATE';
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-formulaire-demat/digicerba-formulaire-demat-web/src/angular/cerba/src/app/common/constants/TypeResultatSaisie.ts